import * as React from "react";
import { LTImg, RTImg, Bottom } from "./styles";
import CountDown from "../CountDown";
export const DiscountInfoCard = (props) => {
    const { ltImg, rtImg, countdownToEnd } = props;
    if (!ltImg && !rtImg && !countdownToEnd) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        ltImg && React.createElement(LTImg, { src: ltImg }),
        rtImg && React.createElement(RTImg, { src: rtImg }),
        React.createElement(Bottom, null,
            React.createElement(CountDown, { countTime: countdownToEnd }))));
};
